import React from "react";
import { FLIGHT_DETAILS_ROUTE_PATH } from "./routes.js";
import { Redirect, useParams, useRouteMatch } from "react-router-dom";
import useGetSearchResultsBound from "../hooks/useGetSearchResultsBound.js";
import { useSelector } from "react-redux";
import { getSearch } from "../store/search/selectors.js";
import { FLIGHT_DETAILS_INBOUND_ROUTE_PATH, FLIGHT_DETAILS_OUTBOUND_ROUTE_PATH } from "@flights/constants";
import { useSplitBoundsCondition } from "../utils/experiments/funnel/flights_split_bounds_us.js";
const BoundsRedirect = ({ children, route }) => {
    const { isSplitBounds } = useSplitBoundsCondition();
    const search = useSelector(getSearch);
    const bound = useGetSearchResultsBound();
    const params = useParams();
    const flightDetails = useRouteMatch({ path: FLIGHT_DETAILS_ROUTE_PATH, exact: true });
    const flightDetailsOutbound = useRouteMatch({ path: FLIGHT_DETAILS_OUTBOUND_ROUTE_PATH, exact: true });
    const flightDetailsInbound = useRouteMatch({ path: FLIGHT_DETAILS_INBOUND_ROUTE_PATH, exact: true });
    const fdParams = flightDetails?.params || flightDetailsOutbound?.params || flightDetailsInbound?.params;
    const id = fdParams?.id;
    const locationSearch = window.location.search;
    if (process.env.BUILD_TARGET === "server")
        return children;
    if (isSplitBounds) {
        if ((route.name === "flightdetails" || route.name === "searchresults") && id && id !== bound) {
            return React.createElement(Redirect, { to: `/flights/${params.airports}/outbound/${id}/${locationSearch}` });
        }
        if (route.name === "searchresults") {
            return React.createElement(Redirect, { to: `/flights/${params.airports}/outbound/${locationSearch}` });
        }
    }
    if ((search.type !== "ROUNDTRIP" && bound) || (!isSplitBounds && bound)) {
        const isAnyBoundsPage = route.name === "flightdetails-outbound" ||
            route.name === "flightdetails-inbound" ||
            route.name === "searchresults-outbound" ||
            route.name === "searchresults-inbound";
        if (isAnyBoundsPage && id && id !== bound) {
            return React.createElement(Redirect, { to: `/flights/${params.airports}/${id}/${locationSearch}` });
        }
        if (route.name === "searchresults-outbound" || route.name === "searchresults-inbound") {
            return React.createElement(Redirect, { to: `/flights/${params.airports}/${locationSearch}` });
        }
    }
    return children;
};
export default BoundsRedirect;
